import { useState, useRef, useEffect } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import cx from 'classnames';
import DotsIcon from '../../components/icons/dots';
import styles from './DropdownMenu.module.scss';
import Switch from '../../components/admin/switch';
import Button from '../../components/Button';
import Loader from '../../components/Loader/Loader';

export const PopoverMenu = ({
  button = <DotsIcon />,
  buttonProps = {},
  className = 'ms-auto',
  itemClassName = '',
  style = {},
  menu,
  item = null,
  items = null,
  popoverProps = {}
}) => {
  const [show, setShow] = useState(false);
  const target = useRef(null);
  const popoverRef = useRef(null);

  if (!menu || !menu?.length) return null;

  const handleClose = () => setShow(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        target.current && !target.current.contains(event.target) &&
        popoverRef.current && !popoverRef.current.contains(event.target)
      ) {
        handleClose();
      }
    };

    if (show) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [show]);

  const popover = (
    <Popover
      id="popover-menu"
      {...popoverProps}
      className={styles.menuContainer}
      ref={popoverRef} // Ensure ref is assigned properly
    >
      <Popover.Body className="p-0">
        {menu.map((a, i) => {
          const Icon = a?.icon;
          const isToggle = a?.type === 'toggle';
          const isButton = a?.type === 'button';
          const isInfo = a?.type === 'info';

          if (a?.hide) return null;

          if (isButton) {
            return (
              <Button
                key={a?.id || i}
                className={cx('w-75 d-flex p-3 m-2 mx-auto', a?.initialValue ? styles.cursorDefault : '')}
                loading={a?.loading}
                color={'primary'}
                onClick={() => {
                  handleClose();
                  a?.onClick();
                }}>
                {a?.title || a?.label}
              </Button>
            );
          }

          return (
            <div
              className={cx(styles.menu, isInfo ? styles.info : '', itemClassName, a?.separate ? styles.line : '')}
              key={a?.id || i}
              onClick={(e) => {
                handleClose();
                if (items) {
                  a?.onClick(items?.id, items?.data, items?.originalData);
                } else {
                  a?.onClick?.('initialValue' in a ? { e: e, value: !a?.initialValue, item } : item);
                }
              }}
              disabled={a?.disabled}>
              {Icon && <Icon style={{ width: 24, height: 24 }} />}
              {isToggle && <Switch checked={a?.initialValue} />}
              {a?.title || a?.label}
            </div>
          );
        })}
      </Popover.Body>
    </Popover>
  );

  // `loading` drives the spinner below; it is not a DOM attribute, so it is kept
  // out of what gets spread onto the <button>.
  const { loading: buttonLoading, ...toggleProps } = buttonProps;

  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom"
      overlay={popover}
      show={show}
      rootClose={true} // Ensures the popover closes on outside click
      onToggle={(nextShow) => setShow(nextShow)}>
      <button
        ref={target}
        className={`${styles.dotBtn} ${styles?.border}`}
        {...toggleProps}
        onClick={() => setShow(!show)}>
        {buttonLoading ? (
          <div className="px-3">
            <Loader loading={true} position="absolute" color="inherit" size={22} thickness={2} />
          </div>
        ) : (
          button
        )}
      </button>
    </OverlayTrigger>
  );
};
